import * as types from './types';

const INITIAL_STATE = {
  loading: false,
  fetchError: null,
  data: null,
  result: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.VERIFICATION_SELECTION_GET_DATA:
      return {
        ...state,
        data: payload,
      };
    case types.VERIFICATION_SELECTION_SET_RESULT:
      return {
        ...state,
        result: payload,
      };
    case types.VERIFICATION_SELECTION_CLEAR_PROCESS_RESULT:
      return {
        ...state,
        result: null,
      };
    case types.VERIFICATION_SELECTION_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.VERIFICATION_SELECTION_LOADING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/verificationselection/state/selection/reducer.js